import requestApi from "./requestApi";
import { API_CONSTANT_MAP } from "./paths";

export const getAllPeriodos = async () => {
  return requestApi.get(API_CONSTANT_MAP.periodoLetivo);
};

export const getPeriodoById = async (id: string | number) => {
  return requestApi.get(`${API_CONSTANT_MAP.periodoLetivo}/${id}`);
};

export const savePeriodo = async (payload: any) => {
  return requestApi.post(API_CONSTANT_MAP.periodoLetivo, payload);
}; 